var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#F06F00",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.785.098c-.113.002-.219.04-.32.11l-10.26 8.1c-.236.19-.27.539-.093.767.174.225.545.261.768.085l9.922-7.83 9.923 7.83c.223.176.583.14.76-.085.174-.222.155-.59-.085-.767L11.14.208c-.12-.08-.241-.113-.355-.11zM4.052 7.363l-1.08.852v8.623c0 .298.242.54.54.54h5.13c.299 0 .54-.242.54-.54v-3.24c0-.907.714-1.62 1.62-1.62.907 0 1.62.713 1.62 1.62v3.24c0 .298.242.54.54.54h5.13c.299 0 .54-.242.54-.54V8.215l-1.08-.852v8.935h-4.05v-2.7c0-1.487-1.213-2.7-2.7-2.7-1.486 0-2.7 1.213-2.7 2.7v2.7h-4.05V7.363z",
    transform: "translate(-16.000000, -13.000000) translate(12.000000, 11.000000) translate(4.000000, 2.000000) translate(0.000000, 0.172211)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive);
export default __webpack_public_path__ + "static/media/home-active.38008a3cbe2e12f3a96c75fba0114f7c.svg";
export { ForwardRef as ReactComponent };